import { ActionIcon } from '@mantine/core';
import Link from 'next/link';
import { Icons } from '../Shares/Icons';
export type SocialLinkItemProps = {
  iconClassName: string;
  href: string;
};
export const SocialLinkItem: React.FC<SocialLinkItemProps> = ({
  iconClassName,
  href
}) => {
  return <ActionIcon component={Link} href={href} bg="var(--bg-500)" w={46} h={46}>
      <Icons className={iconClassName} color="var(--mantine-color-white)" fontSize={24} />
    </ActionIcon>;
};